import { render, staticRenderFns } from "./VeJwCjZhiyeUpdateModalOld.vue?vue&type=template&id=5d81c9ee"
import script from "./VeJwCjZhiyeUpdateModalOld.vue?vue&type=script&lang=js"
export * from "./VeJwCjZhiyeUpdateModalOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports